import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { OrtService } from '../../suchseite/ort.service';
import { BasisFacetteService } from './basis-facette.service';

/*
 Dieser Service dient dazu die UmkreisFacette Anzeigeproblem vorübergehend zu lösen,
 da die Auswahl für Umkreis aus der Suchleiste in die Facette verschoben wurde.
 */
@Injectable({
  providedIn: 'root'
})
export class UmkreisFacettenService implements BasisFacetteService {
  private readonly ortService = inject(OrtService);

  protected _expanded$ = new BehaviorSubject<boolean>(false);
  public expanded$ = this._expanded$.asObservable();

  /**
   * Anzahl der ausgewählten, aktiven Optionen
   */
  public getNumberSelected$(): Observable<number> {
    return this.ortService.ort$.pipe(map((ortOrNull) => (ortOrNull ? 1 : 0)));
  }

  // Setzt den expansion state der Facette
  public setExpanded(expanded: boolean): void {
    this._expanded$.next(expanded);
  }

  public reset() {
    this.ortService.updateOnlyUmkreis(OrtService.UMKREIS_VALUE_GANZER_ORT);
  }

  public setUmkreis(umkreis: string) {
    this.ortService.updateOnlyUmkreis(umkreis);
  }
}
